import "./DataCollection.css";
import InputRowGroup from "./Inputs/InputRowGroup";
import InputRow from "./Inputs/InputRow";
import TextInput from "./Inputs/TextInput";
import LabeledBooleanInput from "./Inputs/LabeledBooleanInput";
import DateInput from "./Inputs/DateInput";
import SINInput from "./Inputs/SINInput";
import { handleChange, sinValidation } from "../Utils/DataCollectionUtils";
import { useTranslation } from "react-i18next";
import DropdownInput from "./Inputs/DropdownInput";
import { beneficiaryAge, GENDERS } from "../Utils/PlanUtils";
import { useParams } from "react-router-dom";

const BeneficiaryDataCollection = ({ state }) => {
    const { t } = useTranslation();
    const beneficiary = state.beneficiary;
    const setBeneficiary = state.setBeneficiary;
    const application = state.application;
    const setApplication = state.setApplication;

    const params = useParams();

    return (
        <form>
            <InputRowGroup label={t("Beneficiary")}>
                <InputRow label={t("Name")}>
                    <TextInput
                        placeholder={t("Given Name")}
                        name={"firstName"}
                        state={beneficiary}
                        onChange={handleChange(setBeneficiary)}
                        autoFocus={params.item === 'beneficiary.givenName'}
                    />
                    <TextInput
                        placeholder={t("Middle Name")}
                        name={"middleName"}
                        state={beneficiary}
                        onChange={handleChange(setBeneficiary)}
                    />
                    <TextInput
                        placeholder={t("Last Name")}
                        name={"lastName"}
                        state={beneficiary}
                        onChange={handleChange(setBeneficiary)}
                    />
                </InputRow>
                <InputRow label={t("Social Insurance Number")}>
                    <SINInput
                        placeholder={t("Social Insurance Number")}
                        name={"sin"}
                        state={beneficiary}
                        maxLength={12}
                        onChange={handleChange(setBeneficiary)}
                        validationCallback={sinValidation}
                    />
                </InputRow>
                <InputRow label={t("Gender")}>
                    <DropdownInput
                        state={beneficiary}
                        name={'gender'}
                        onChange={handleChange(setBeneficiary)}
                        options={GENDERS}
                    />
                </InputRow>
                <InputRow label={t("Date of Birth")}>
                    <DateInput
                        name={"birthdate"}
                        state={beneficiary}
                        onChange={handleChange(setBeneficiary)}
                        maxDate={new Date().toISOString().split("T")[0]}
                    />
                </InputRow>
                <InputRow label={t("Certificate Inscription")} presetValues={
                    [
                        t("Inscript_1"),
                        t("Inscript_2"),
                        t("Inscript_3"),
                        t("Inscript_4"),
                        t("Inscript_5"),
                        t("Inscript_6"),
                        t("Inscript_7"),
                        t("Inscript_8"),
                        t("Inscript_9"),
                        t("Inscript_10"),
                        t("Inscript_11"),
                        t("Inscript_12"),
                        t("Inscript_13"),
                        t("Inscript_14"),
                        t("Inscript_15"),
                        t("Inscript_16"),
                        t("Inscript_17"),
                        t("Inscript_18"),
                        t("Inscript_19"),
                        t("Inscript_20"),
                        t("Inscript_21"),
                        t("Inscript_22"),
                        t("Inscript_23"),
                        t("Inscript_24"),
                        t("Inscript_25"),
                        t("Inscript_26"),
                        t("Inscript_27"),
                        t("Inscript_28"),
                    ]
                } onPresetSelected={(preset) => {
                    setApplication({ ...application, beneficiaryCertificateInscription: preset });
                }}>
                    <TextInput
                        placeholder={t("Certificate Inscription")}
                        name={"beneficiaryCertificateInscription"}
                        state={application}
                        maxLength={40}
                        onChange={handleChange(setApplication)}
                    />
                </InputRow>
                <InputRow label={t("Relationship to Subscriber")} presetValues={
                    [
                        t("Son"),
                        t("Daughter"),
                        t("Grandson"),
                        t("Granddaughter"),
                        t("Nephew"),
                        t("Niece"),
                        t("Not related"),
                        t("Agency"),
                        t("Other")
                    ]
                } onPresetSelected={(preset) => {
                    setBeneficiary({ ...beneficiary, relationshipToSubscriber: preset });
                }}>
                    <TextInput
                        placeholder={t("Relationship")}
                        name={"relationshipToSubscriber"}
                        state={beneficiary}
                        maxLength={20}
                        onChange={handleChange(setBeneficiary)}
                    />
                </InputRow>
                <InputRow label={t("Previous Agreement Number")}>
                    <TextInput
                        placeholder={t("Agreement Number")}
                        name={"agreementNumber"}
                        state={application.agreementNumber}
                        maxLength={20}
                        onChange={handleChange(setApplication)}
                    />
                </InputRow>

                {/*if bene is older than 18 their info is needed for signing*/}
                {beneficiaryAge(beneficiary.birthdate) >= 18 && <>
                    <InputRow label={t('E-Mail Address')}>
                        <TextInput
                            placeholder={t('E-Mail Address')}
                            name={'email'}
                            state={beneficiary}
                            onChange={handleChange(state.setBeneficiary)}
                            validationRules={{
                                pattern: {
                                    value: /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/
                                }
                            }}
                            autoFocus={params.item === 'beneficiary.email'}
                            validationFailedMessage={'The E-Mail address entered was invalid'}
                        />
                    </InputRow>

                    <InputRow label={t('Mobile Phone Number')}>
                        +1
                        <TextInput
                            placeholder={t('Mobile Phone Number')}
                            name={'mobilePhone'}
                            state={beneficiary}
                            onChange={handleChange(state.setBeneficiary)}
                            validationRules={{
                                pattern: {
                                    value: /^\(?\d{3}\)?[- ]?\d{3}[- ]?\d{4}$/
                                }
                            }}
                            autoFocus={params.item === 'beneficiary.mobilePhone'}
                            validationFailedMessage={'The phone number entered was invalid'}
                        />
                        <div className={'info'}>
                            As a security precaution, a text message may be sent to this number during the signing
                            process to verify the identity of the beneficiary.
                        </div>
                    </InputRow>


                    <InputRow label={t("Signing Method")}>
                        <DropdownInput
                            name={'inPersonSigner'}
                            state={beneficiary}
                            onChange={handleChange(state.setBeneficiary)}
                            options={[{ label: t('In Person'), value: true }, { label: t('Remote'), value: false }]}
                            booleanValue={true}
                        />
                    </InputRow>
                </>}
            </InputRowGroup>
        </form>
    );
};

export default BeneficiaryDataCollection;
